import React from 'react';

const SkillItem = ({ icon, text }) => {
  return (
    <div className="flex items-center">
      <div className="flex items-center justify-center w-8 h-8 bg-apple-gray-500 rounded-full mr-3">
        {icon}
      </div>
      <span className="text-apple-gray-700 text-sm">{text}</span>
    </div>
  );
};

export default SkillItem;